"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var DescriptionsItem = function DescriptionsItem(_ref) {
  var children = _ref.children;
  return children;
};
var _default = DescriptionsItem;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/descriptions/Item.js
// module id = 842
// module chunks = 0